export default __webpack_public_path__ + "static/media/sparck-appreciation-card-header-5.761a0a48.png";